import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
export var Value = [String, Number, Object];
export var PrimitiveValue = [String, Number];
export var responsiveMap = {
  xxl: "(min-width: 1400px)",
  xl: "(min-width: 1200px)",
  lg: "(min-width: 992px)",
  md: "(min-width: 768px)",
  sm: "(min-width: 576px)",
  xs: "(max-width: 575px)"
};
export var breakpoints = _Object$keys(responsiveMap);